import Tatacapital from "../../../jsx/components/Dashboard/TataCapital/tatacapital";

const TataCapitalWrapper = () => {
  return <Tatacapital />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.connector,
  _enum.ROUTE_PERSONAS.manager,
];

export default constore(TataCapitalWrapper);
